import styled from 'styled-components'
import { getStepItemContainerStyles, StepStatus } from '../style'
import { StepperSize } from '../type'

interface StyledStepItemProps {
    status: StepStatus
    isClickable: boolean
    isLastStep: boolean
    size?: StepperSize
}

const StyledStepItem = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !['status', 'isClickable', 'isLastStep', 'size'].includes(prop)
})<StyledStepItemProps>(
    ({ theme, status, isClickable, isLastStep, size = 'md' }) =>
        getStepItemContainerStyles({
            theme,
            status,
            isClickable,
            isLastStep,
            size
        })
)

export default StyledStepItem
